import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { ApiResponse } from '../api-response.model';
import { EducationDegreeDto } from '../fn/generals/education.model';

@Injectable({
  providedIn: 'root',
})
export class EducationDegreeService {
  constructor(private http: HttpClient, private config: ApiConfiguration) { }

  getActiveEducationDegrees(): Observable<ApiResponse<{ educations: EducationDegreeDto[] }>> {
    const url = `${this.config.rootUrl}/grado-educacion/activos`;
    return this.http.get<ApiResponse<{ educations: EducationDegreeDto[] }>>(url);
  }
}
